import { ImageManagementSection } from '@/components/shared/ImageManagementSection';
import { useCostImages } from '../hooks/useCostImages';
import { useUploadCostImages } from '../hooks/useUploadCostImages';

export interface CostImagesSectionProps {
  jobId: number;
  costId: number;
  canDelete?: boolean;
}

/**
 * Cost-specific image management section
 * Thin wrapper around ImageManagementSection with cost-specific hooks
 */
export function CostImagesSection({ jobId, costId, canDelete = false }: CostImagesSectionProps) {
  const { images, isLoading, error: fetchError, refetch, deleteImage } = useCostImages(jobId, costId);
  const { uploadImages, isUploading, error: uploadError } = useUploadCostImages(jobId, costId, refetch);

  return (
    <ImageManagementSection
      images={images}
      isLoading={isLoading}
      fetchError={fetchError}
      uploadError={uploadError}
      isUploading={isUploading}
      onUpload={uploadImages}
      onDelete={deleteImage}
      canDelete={canDelete}
      uploadLabel="Upload Images"
      galleryLabel="Uploaded Images"
    />
  );
}
